import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.onScroll = this.onScroll.bind(this)
        this.scrollParent = this.getScrollParent(this.element)

        this.scrollParent.addEventListener("scroll", this.onScroll, { passive: true })
        if (this.scrollParent !== window) {
            // Also listen to window scroll just in case layout shifts
            window.addEventListener("scroll", this.onScroll, { passive: true })
        }

        // Initial calculation
        this.onScroll()
    }

    disconnect() {
        if (this.scrollParent) {
            this.scrollParent.removeEventListener("scroll", this.onScroll)
        }
        window.removeEventListener("scroll", this.onScroll)
        this.resetHeaders()
    }

    getScrollParent(node) {
        if (node == null) {
            return window
        }

        if (node.scrollHeight > node.clientHeight) {
            const overflowY = window.getComputedStyle(node).overflowY
            const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden'
            if (isScrollable) {
                return node
            }
        }
        return this.getScrollParent(node.parentNode)
    }

    resetHeaders() {
        const headers = this.element.querySelectorAll("thead th")
        headers.forEach(th => {
            th.style.transform = ""
        })
    }

    onScroll() {
        const tableRect = this.element.getBoundingClientRect()

        // Configurable offset for fixed headers (navbar)
        // You can set this via data-sticky-header-offset-value="60" if needed
        const offset = 0

        // Determine the top boundary relative to the viewport
        // If we are in a scroll container, we might need to check the container's top
        // But getBoundingClientRect returns viewport coordinates, so raw 0 (top of screen) is usually correct check for "stuck"
        // EXCEPT if the scroll container itself is offset

        let containerTop = 0
        if (this.scrollParent !== window) {
            const parentRect = this.scrollParent.getBoundingClientRect()
            containerTop = parentRect.top
        }

        // The "sticky" line is max(0, containerTop) + offset
        const stickyLine = Math.max(0, containerTop) + offset

        const headers = this.element.querySelectorAll("thead th")
        if (headers.length === 0) return

        // Calculate translation
        let translateY = 0

        // If the table's top edge has scrolled PAST the sticky line...
        if (tableRect.top < stickyLine) {
            // We need to push the header DOWN by the difference
            translateY = stickyLine - tableRect.top

            // But we must NOT push it past the bottom of the table
            const headerHeight = headers[0].offsetHeight
            const maxTranslate = tableRect.height - headerHeight

            if (translateY > maxTranslate) {
                translateY = maxTranslate
            }
        }

        // Apply translation
        requestAnimationFrame(() => {
            headers.forEach(th => {
                if (translateY > 0) {
                    th.style.transform = `translateY(${translateY}px)`
                    th.style.zIndex = "20" // Ensure it stays on top
                    // th.style.position = "relative" // Transform implicitly creates context, but relative helps safely
                } else {
                    th.style.transform = ""
                    th.style.zIndex = ""
                }
            })
        })
    }
}
